import { useContext, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import Box from 'components/ui/box';
import { getFaq } from 'services/content.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import FaqItem from './FaqItem';
import { RiArrowLeftSLine } from 'react-icons/ri';
import CustomSelect from 'components/custom-select';
import { getIndexByValue } from 'utils/helpers';
import { AuthContext } from 'context/AuthContext';
import TabTitle from 'components/tab-title';

export default function Faq() {
  const [faqList, setFaqList] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const [optionsCycle, setOptionsCycle] = useState<any>([]);

  const { realCycle, user } = useContext(AuthContext);

  useEffect(() => {
    async function loadData() {
      if (!activeItem || !user?.extra) return;
      setLoading(true);
      const data = await getFaq(!!activeItem ? activeItem : '', user?.extra?.rede);
      if (data) {
        setFaqList(data);
      }
      setLoading(false);
    }
    loadData();
  }, [activeItem, user]);

  useEffect(() => {
    if (!realCycle || !user?.extra) return;
    console.log(realCycle);

    const cycleOptions = realCycle
      .filter(
        (item: any) =>
          (user?.extra?.rede && item?.date_start >= 1706886000000) || (!user?.extra?.rede && item?.date_start >= 1690772400000),
      )
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle, user]);

  return (
    <div className="mx-auto container p-3 lg:p-10">
      <div className="flex flex-ro items-center space-x-3 lg:space-x-6 mb-3 lg:mb-10">
        <div>
          <Link to="../">
            <button className="rounded-full bg-purple flex justify-center items-center p-1">
              <RiArrowLeftSLine size={28} className="text-white" />
            </button>
          </Link>
        </div>
        <h1 className="text-xl lg:text-3xl">Ajuda</h1>
      </div>

      <div className="space-y-5">
        <h2
          className="p-2 lg:p-0 rounded-lg bg-blue-dark lg:bg-transparent lg:text-2xl font-bold text-justify relative"
          tabIndex={0}
        >
          Encontre respostas para suas dúvidas rapidamente. Acesse as principais dúvidas dos nossos clientes ou clique na dúvida
          específica da FLAP 360°.
        </h2>

        <TabTitle
          title={
            <div className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
              <p>FAQ</p>
            </div>
          }
          options={optionsCycle}
          key={1}
          onCallBack={e => setActiveItem(e.value)}
        />

        {/* <div className="mb-5 flex flex-col-reverse lg:flex-row  items-center justify-between lg:space-x-5">
          <div className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
            <p>
              FAQ | <span className="text-yellow"> {activeCycleObj?.label}</span>
            </p>
          </div>

          <div className="w-full mb-3 lg:mb-0 lg:w-[264px]">
            <CustomSelect
              placeholder="Clique para selecionar o ciclo"
              options={optionsCycle}
              value={activeCycleObj}
              onChange={(e: any) => setActiveItem(e.value)}
            />
          </div>
        </div> */}

        <Box>
          <div className="space-y-3">
            {!!loading && (
              <>
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </>
            )}

            {!loading && !!faqList && faqList.map((item: any) => <FaqItem key={item._id} _id={item._id} title={item.title} />)}
          </div>
        </Box>

        {/* <Box className="relative px-3 py-3">
          <div className="flex-1 flex flex-row-reverse lg:flex-row items-center space-x-4">
            <div className="w-1/3 lg:w-[128px]"></div>
            <div className="flex-1 lg:text-lg">
              <b className="text-yellow">Dúvidas? Digite FLAP 360°</b>
              <br />e converse com um especialista em dias úteis de 9 às 18h (horário de Brasília)
            </div>
          </div>
        </Box> */}
      </div>
    </div>
  );
}
